import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import _ from "lodash";
import uuidv1 from "uuid/v1";
//custom import
import FormLayoutVertical from "../../components/FormLayoutVertical";
import FormFooter from "../../components/FormFooter";
import Logo from "../../components/Logo";
import { toast } from "react-toastify";
import * as MSG from "../../constants/Messages.js";
import { execRegisterStaff } from "../../actions/services/api-staff";
import Spinner from "../../components/Spinner";
import { GOLDEN_HEALTH_ORANGE } from "../../constants/Colors";
import { BOUNCE } from "../../constants/Loaders";
import ActivateCompanyPostModel from "../../models/activateCompanyPostModel";
import {execGetUserDetail, execUpdate} from "../../actions/services/api-user";
import * as RULE from "../../constants/Rules";

const mapDispatchToProps = dispatch => ({
  register: (data) => dispatch(execRegisterStaff(data)),
  goToDashboard: () => dispatch({ type: "RTE_DASHBOARD" }),
  getUserDetail: (id) => dispatch(execGetUserDetail(id)),
  updateUser: (data) => dispatch(execUpdate(data)),
});

const mapStateToProps = ({ location }) => ({
  location: location,
});

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "calc(100% - 10px)"
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
  },
  customControl: {
    margin: 8
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: "#2698D6",
    color: "#fff",
  },
});


const  initialState = () => ({
  data: new ActivateCompanyPostModel(),
  loading: false,
  isUpdateUser: false,
});

class DangKyNhanVien extends React.Component {

  state = initialState();

  componentDidMount() {
    this.initializeScreen();
    ValidatorForm.addValidationRule('isEmailMatch', (value) => {
      if (value !== this.state.data.email) {
        return false;
      }
      return true;
    });
  }

  initializeScreen = async () => {
    try{
      const { id } = this.props.location.payload;
      const response = id ? await this.props.getUserDetail(id) : {};
      const user = response.status === 200 ? new ActivateCompanyPostModel(response.json) : new ActivateCompanyPostModel();
      this.setState({data: user, isUpdateUser: !!id});

    }catch(err){
      console.err(err);
    }
  };

  handleChange = name => event => {
    let data = { ...this.state.data };
    data[name] = event.target.value;
    this.setState({ data: data });
  };

  handleSubmit = async () => {
    try{
      const { id } = this.props.location.payload;
      const { data } = this.state;
      this.setState({loading: true});
      let result = null;
      if (!id) {
        result = await this.props.register(data);
        if (result.status === 200 || result.status === 201)
          return result.json.isSuccess ? this.handleCreateSuccess() : this.handleError({
            detail: result,
            message: result.json.errorMessage
          });
      } else {
        result = await this.props.updateUser({...data, userId: id});
        return result.status === 200 ? this.handleUpdateSuccess() : this.handleError({
          detail: result,
          message: MSG.USER.UPDATE.FAILED
        });
      }

      this.handleError({detail: result, message: MSG.ERROR_OCCURED});
    }catch(err){
      this.handleError({detail: err, message: MSG.ERROR_OCCURED})
    }
  };

  handleUpdateSuccess = () => {
    toast.success(MSG.USER.UPDATE.SUCCESS);
    this.setState({loading: false});
  };

  handleCreateSuccess = () => {
    toast.success(MSG.ACTIVATE_COMPANY_SUCCESS);
    const { state } = this;
    const newState = initialState();
    //newState.companies = [...state.companies];
    newState.dropdownKey = uuidv1();
    this.setState({...newState});
  };

  handleError = (err) => {
    toast.error(err.message);
    this.setState({loading: false});
    console.error(err.detail);
  };

  render() {

    const { classes, goToDashboard } = this.props;
    const { loading, data, companies, dropdownKey, selectedItems, isUpdateUser } = this.state;

    return (
      <FormLayoutVertical>
        <Spinner type={BOUNCE} size={50} color={GOLDEN_HEALTH_ORANGE} loading={loading} />
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={errors => console.log(errors)}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Logo onClick={goToDashboard} size={150} />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography component="h1" variant="h4" align="center">
                  Đăng ký
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2}>

            <Grid item xs={12} sm={6}>
              <TextValidator
                label="Tên nhân viên"
                className={classes.textField}
                value={data.ten}
                onChange={this.handleChange('ten')}
                margin="normal"
              />
            </Grid>


            <Grid item xs={12} sm={6}>
              <TextValidator
                label="Số điện thoại"
                className={classes.textField}
                value={data.phone}
                validators={[RULE.IS_REQUIRED]}
                errorMessages={[MSG.REQUIRED_FIELD]}
                onChange={this.handleChange('phone')}
                margin="normal"
              />
            </Grid>


            <Grid item xs={12} sm={6}>
              <TextValidator
                label="Email"
                className={classes.textField}
                value={data.email}
                validators={[RULE.IS_REQUIRED, RULE.IS_EMAIL]}
                errorMessages={[MSG.REQUIRED_FIELD, MSG.INVALID_EMAIL]}
                onChange={this.handleChange('email')}
                margin="normal"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextValidator
                  label="Nhập lại Email"
                  className={classes.textField}
                  value={data.re_email || ""}
                  validators={[RULE.IS_REQUIRED, "isEmailMatch", RULE.IS_EMAIL]}
                  errorMessages={[MSG.REQUIRED_FIELD, MSG.EMAIL_DOES_NOT_MATCH, MSG.INVALID_EMAIL]}
                  onChange={this.handleChange('re_email')}
                  margin="normal"
              />
            </Grid>


            <Grid item xs={12} sm={6}>
              <TextValidator
                label="Mật khẩu"
                type="password"
                className={classes.textField}
                value={data.password}
                autoComplete={"true"}
                onChange={this.handleChange('password')}
                margin="normal"
              />
            </Grid>

            <Grid item xs={12}>
              <Button type="submit" variant="contained" className={classes.button}>
                {isUpdateUser ? 'Cập nhật' : 'Đăng ký'}
              </Button>
            </Grid>
            <FormFooter />
          </Grid>
        </ValidatorForm>

      </FormLayoutVertical>
    );
  }
}

DangKyNhanVien.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DangKyNhanVien));
